import { useEffect, useState } from 'react'

/**
 * App-wide notices, raised from anywhere with
 * `window.dispatchEvent(new CustomEvent('lereco:toast', { detail: { kind, message } }))`
 * — used for "sample data, simulated" today. Top-right, so it never sits on
 * a page's own toasts in the bottom corner.
 */
export default function Toaster() {
  const [toasts, setToasts] = useState([])
  useEffect(() => {
    const onToast = (e) => {
      const id = Math.random().toString(36).slice(2)
      const t = { id, kind: e.detail?.kind ?? 'info', message: e.detail?.message ?? '' }
      setToasts((list) => [...list.filter((x) => x.message !== t.message), t].slice(-3))
      setTimeout(() => setToasts((list) => list.filter((x) => x.id !== id)), 3500)
    }
    window.addEventListener('lereco:toast', onToast)
    return () => window.removeEventListener('lereco:toast', onToast)
  }, [])
  if (!toasts.length) return null
  return (
    <div className="toast-wrap toast-global" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.kind}`}>
          {t.message}
        </div>
      ))}
    </div>
  )
}
